import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVIRONMENT } from '../../constants/env-constants';
import { createBearerBaseQuery } from '../../shared/rtk-bearer-base-query';
import { logoutSignOutAndCleanup } from '../../shared/utils';

export const subscriptionApi = createApi({
  reducerPath: 'subscription-redux-query',
  baseQuery: createBearerBaseQuery(`${ENVIRONMENT.BACKEND_SERVER}/api/platform/subscription`),
  endpoints: (build) => ({
    billingLinkTrial: build.query({
      query: ({ id, params }) => {
        let query = `id=${id}`;
        Object.keys(params).forEach((key) => {
          const value = params[key];
          query += `&${key}=${value}`;
        });
        return `/billing-link-trial?${query}`;
      },
    }),

    cancelSubscription: build.query({
      query: () => `/cancel`,
    }),

    changePaymentMethod: build.mutation({
      query: (data) => ({
        url: '/change_payment',
        method: 'POST',
        body: data,
      }),
    }),

    checkoutSession: build.query({
      query: ({ id, typeOperation }) => `/checkout-session?priceId=${id}&typeOperation=${typeOperation}`,
    }),

    checkoutData: build.query({
      query: (id) => `/checkout?sessionId=${id}`,
    }),

    createSubscription: build.mutation({
      query: (data) => ({
        url: '/create-subscription',
        method: 'POST',
        body: data,
      }),
    }),

    intent: build.query({
      query: () => '/intent',
    }),

    paymentHistory: build.query({
      query: () => `/payment-history`,
    }),

    prices: build.query({
      query: () => `/all-prices`,
    }),

    subscription: build.query({
      query: (args) => {
        return {
          url: '/details',
          headers: {
            'Cache-Control': !args?.fromCache ? 'no-cache' : 'public, max-age=30, s-maxage=30',
          },
        };
      },
      transformErrorResponse: (response) => {
        const { status } = response;
        if ([401, 403].includes(Number(status))) {
          if (!['/user/logout'].includes(window.location.pathname)) {
            logoutSignOutAndCleanup();
          }
        }
        return response;
      },
      transformResponse: (response) => {
        return response?.data || response;
      },
    }),

    updateSubscription: build.mutation({
      query: (data) => ({
        url: '/update-subscription',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useChangePaymentMethodMutation,
  useCreateSubscriptionMutation,
  useLazyBillingLinkTrialQuery,
  useLazyCancelSubscriptionQuery,
  useLazyCheckoutDataQuery,
  useLazyCheckoutSessionQuery,
  useLazyIntentQuery,
  useLazyPricesQuery,
  useLazySubscriptionQuery,
  usePaymentHistoryQuery,
  usePricesQuery,
  useUpdateSubscriptionMutation,
  useSubscriptionQuery,
} = subscriptionApi;
